import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export default function FanPollPublishDialog({ open, published, label, scheduled, onClose, onConfirm }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{published ? 'Unpublish' : 'Publish'} {label || 'fan poll'}</DialogTitle>
            <DialogContent>
                Are you sure you want to {published ? 'unpublish' : 'publish'} this poll?
                {!published && scheduled && <Alert severity="info" sx={{ mt: 2 }}>The poll will be published as scheduled and will open at its start date.</Alert>}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" color={published ? 'error' : 'success'} onClick={onConfirm}>
                    {published ? 'Unpublish' : 'Publish'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
